import React from 'react';
interface CTAButtonProps {
  children: React.ReactNode;
  className?: string;
  fullWidth?: boolean;
}
export function CTAButton({
  children,
  className = '',
  fullWidth = false
}: CTAButtonProps) {
  const scrollToOffer = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    const offerSection = document.getElementById('oferta');
    if (offerSection) {
      offerSection.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <a href="#oferta" onClick={scrollToOffer} className={`
        inline-flex items-center justify-center
        bg-gold hover:bg-gold-hover text-navy
        font-black text-lg md:text-xl py-4 px-8 rounded-full
        uppercase tracking-wide
        transition-all duration-300 transform hover:scale-105 hover:shadow-[0_10px_40px_rgba(212,168,90,0.4)]
        ${fullWidth ? 'w-full' : ''}
        ${className}
      `} data-id="element-340">
      {children}
    </a>;
}